<template>
  <div class="detail_body">
    <v-head title="抬头信息" :sdata="sdata"></v-head>
    <div class="coll">
      <h2 class="title">
        <span>物料明细</span>
      </h2>
      <!-- 操作按钮  -->
      <span
        class="btn right_sub_btn save_btn"
        @click.stop="onChange"
        style="margin-top:4%;margin-right:3%;"
      >销售转生产</span>
      <tab-list
        :tabList="sdata.details"
        @selectSdata="selectSdata"
        :columns="tabColumns"
        setHeadBtn
        tabName="business-sale-orderListDetail"
        tabHeight="500"
      ></tab-list>
    </div>
  </div>
</template>

<script>
import { queryOrder } from "api/business.js";
import vHead from "./components/detail/head.vue";
import tabList from "components/table/list.vue";
export default {
  props: {
    sdata: Object,
  },
  components: {
    vHead,
    tabList
  },
  data() {
    return {
      tabColumns: [
        {
          field: "materialCode",
          title: "物料编码",
          width: 100,
          sortable: true
        },
        { field: "materialDesc", title: "物料描述"},
        { field: "targetUnitDesc", title: "计量单位"},
        { field: "factoryCode", title: "工厂编码"},
        { field: "factoryDesc", title: "工厂描述"},
        { field: "inventoryDesc", title: "库存地点"},
        { field: "targetNum", title: "数量"},
        { field: "deliveryDate", title: "交货日期",sortable: true},
        { field: "netPrice", title: "销售价格"},
        { field: "taxm1", title: "销项税"},
        { field: "materialGroup", title: "物料组"}
      ] //表头字段
    };
  }, 
  created() {
  },
  methods: {
    //点击销售订单转生产订单
    async onChange() {
      console.log(this.$store.state.cache.detailData.details.length);
     if(this.$store.state.cache.detailData.details.length !== 1){
        this.$message.error('请点击单条选择需要转的记录！');
        return;
      }
      this.$router.push({name: 'business-production-orderNew', params:{changeStatus:1}});
    },
    //单击选中数据
    selectSdata(val) {
      this.$store.state.cache.detailData.details = []
      this.$store.state.cache.detailData.details[0] = val
      console.log(this.$store.state.cache.detailData);
    },
  }
};
</script>

<style>
</style>
